import { render, staticRenderFns } from "./SummaryChart.vue?vue&type=template&id=58d336d3&"
import script from "./SummaryChart.vue?vue&type=script&lang=js&"
export * from "./SummaryChart.vue?vue&type=script&lang=js&"
import style0 from "./SummaryChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports